import devConfig from './dev';
import qaConfig from './qa';
import stagingConfig from './staging';
import prodConfig from './prod';

export type Environment = 'development' | 'qa' | 'staging' | 'production';

export interface Config {
  calculationApiUrl: string;
  debug: boolean;
  version: string;
  environment: Environment;
}

const configs: Record<Environment, Config> = {
  development: devConfig,
  qa: qaConfig,
  staging: stagingConfig,
  production: prodConfig,
};

export const getConfig = (env: Environment = 'development'): Config => {
  return configs[env];
};

export default getConfig;